import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { InfoPage, PortalOneColumnLayout } from 'components/PortalStructure';
import { InfoPageHeaderSection, InfoPageHeaderTitle, InfoPageSection, InfoPageTitle1 } from 'components';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router';
const { asyncConnect } = require('redux-connect');

interface IProps {
	baseUrlClient?: string;
}

@asyncConnect([
	{
		promise: () => {
			return Promise.all([]);
		},
	},
])
@connect((state: IStore) => ({
	baseUrlClient: state.fetchDefault.baseUrlClient,
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalDeleteAccountSL extends React.Component<IProps, any> {
	public render() {
		const siteTitle = 'Brisanje računa';
		const siteDescription =
			'Ko izbrišeš svoj račun, bodo vsi tvoji podatki trajno odstranjeni. Zaradi varnostnih razlogov ne moremo izbrisati računa namesto tebe. Če želiš zahtevati izbris, se boš moral/a prijaviti v svoj račun.';
		const siteKeywords = 'Delete account keywords';
		const siteImage = this.props.baseUrlClient + '/images/logo.png';
		const siteUrl = this.props.baseUrlClient + '/deleteaccount/sl';

		return (
			<PortalOneColumnLayout>
				<InfoPage>
					<InfoPageHeaderSection>
						<img src={require('../../../containers/Html/icons/symbol1.svg')} alt="glossiq icon" />
						<InfoPageHeaderTitle>Brisanje računa</InfoPageHeaderTitle>
					</InfoPageHeaderSection>
					<hr />
					<InfoPageSection>
						<p>
							Ko izbrišeš svoj račun, bodo vsi tvoji podatki trajno odstranjeni. Zaradi varnostnih razlogov ne moremo
							izbrisati računa namesto tebe. Če želiš zahtevati izbris, se boš moral/a prijaviti v svoj račun.
						</p>

						<InfoPageTitle1>Če želiš zahtevati trajni izbris računa: </InfoPageTitle1>

						<ul>
							<li>
								Prijavi se v svoj račun: Obišči spletno stran Glossiq.com preko računalnika ali odpri mobilno aplikacijo
								in se prijavi z uporabo uporabniškega imena in gesla za račun.
							</li>

							<li>
								Poišči nastavitve računa: V računalniku klikni sliko svojega profila v zgornjem desnem kotu zaslona in
								nato klikni na <Link to="/account">Nastavitve</Link>. V mobilni aplikaciji klikni na Profil v desnem
								kotu gumba in nato klikni na Račun.
							</li>

							<li>
								Dostop do možnosti izbrisa računa: Premakni se navzdol do razdelka Onemogoči račun in klikni na gumb
								"Onemogoči moj račun".
							</li>

							<li>Potrdi svojo namero o izbrisu: Če si prepričan/a o izbrisu računa, klikni na gumb 'Naprej'.</li>

							<li>
								Podaj povratne informacije: navedi razlog za svojo odločitev ali izberite možnost 'Drugo', če ga ne
								želiš deliti, nato pa klikni na gumb 'Onemogoči moj račun', da začneš postopek brisanja.
							</li>

							<li>Preveri svojo e-pošto: Prejel/a boš potrditveno sporočilo, ki potrjuje izbris tvojega računa.</li>
						</ul>

						<p>
							Po 7 dneh od zahteve za izbris računa bodo tvoj račun in vsi tvoji podatki trajno izbrisani in se jih ne
							bo dalo ponovno pridobiti.
						</p>
					</InfoPageSection>
				</InfoPage>
				<Helmet
					title={siteTitle}
					link={[{ rel: 'canonical', href: siteUrl }]}
					meta={[
						{ property: 'og:title', content: siteTitle },
						{ property: 'og:image', content: siteImage },
						{ property: 'og:description', content: siteDescription },
						{ property: 'og:url', content: siteUrl },
						{ name: 'title', content: siteTitle },
						{ name: 'description', content: siteDescription },
						{ name: 'keywords', content: siteKeywords },
					]}
				/>
			</PortalOneColumnLayout>
		);
	}
}

export { PortalDeleteAccountSL };
